helpPagePrevButton = {};

helpPagePrevButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);

  button.canEnable = function () {
    return !helpPageManager.pageSwapDisable;
  };

  button.canShow = function () {
    return true;
  };

  button.onPressedCallback = function () {
    helpPageManager.previousPage();
    if (button.soundName !== "") button.playSound();
  };

  return button;
};

helpPagePrevButton.initialise = function (json, object) {
  object.soundName = json.soundName || "";
};
helpPagePrevButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "helpPagePrevButton",
  helpPagePrevButton.create,
  helpPagePrevButton.initialise,
  helpPagePrevButton.getFilesRequired
);
